var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.805 43.0501L426.899 84.1436L385.805 125.237L344.712 84.1435L385.805 43.0501Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.805 43.0501L426.899 84.1436L385.805 125.237L344.712 84.1435L385.805 43.0501Z",
    fill: "url(#paint0_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.159 124.883L345.066 83.79L344.358 84.4971L385.452 125.591L386.159 124.883Z",
    fill: "black",
    mask: "url(#path-1-inside-1_201_12134)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.805 129.15L426.899 170.244L385.805 211.337L344.712 170.244L385.805 129.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.805 129.15L426.899 170.244L385.805 211.337L344.712 170.244L385.805 129.15Z",
    fill: "url(#paint1_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.159 210.984L345.066 169.89L344.358 170.597L385.452 211.691L386.159 210.984Z",
    fill: "black",
    mask: "url(#path-3-inside-2_201_12134)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.805 215.25L426.899 256.344L385.805 297.437L344.712 256.344L385.805 215.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.805 215.25L426.899 256.344L385.805 297.437L344.712 256.344L385.805 215.25Z",
    fill: "url(#paint2_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.159 297.084L345.066 255.99L344.358 256.697L385.452 297.791L386.159 297.084Z",
    fill: "black",
    mask: "url(#path-5-inside-3_201_12134)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.805 301.353L426.899 342.446L385.805 383.54L344.712 342.446L385.805 301.353Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.805 301.353L426.899 342.446L385.805 383.54L344.712 342.446L385.805 301.353Z",
    fill: "url(#paint3_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.159 383.186L345.066 342.093L344.358 342.8L385.452 383.893L386.159 383.186Z",
    fill: "black",
    mask: "url(#path-7-inside-4_201_12134)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.805 387.452L426.899 428.545L385.805 469.639L344.712 428.545L385.805 387.452Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.805 387.452L426.899 428.545L385.805 469.639L344.712 428.545L385.805 387.452Z",
    fill: "url(#paint4_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.159 469.285L345.066 428.192L344.358 428.899L385.452 469.992L386.159 469.285Z",
    fill: "black",
    mask: "url(#path-9-inside-5_201_12134)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.705 43.0501L340.799 84.1436L299.705 125.237L258.612 84.1435L299.705 43.0501Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.705 43.0501L340.799 84.1436L299.705 125.237L258.612 84.1435L299.705 43.0501Z",
    fill: "url(#paint5_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.059 124.883L258.965 83.79L258.258 84.4971L299.352 125.591L300.059 124.883Z",
    fill: "black",
    mask: "url(#path-11-inside-6_201_12134)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.756 86.1005L383.849 127.194L342.756 168.287L301.662 127.194L342.756 86.1005Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.756 86.1005L383.849 127.194L342.756 168.287L301.662 127.194L342.756 86.1005Z",
    fill: "url(#paint6_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.109 167.934L302.016 126.84L301.309 127.548L342.402 168.641L343.109 167.934Z",
    fill: "black",
    mask: "url(#path-13-inside-7_201_12134)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.756 172.2L383.849 213.293L342.756 254.387L301.662 213.293L342.756 172.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.756 172.2L383.849 213.293L342.756 254.387L301.662 213.293L342.756 172.2Z",
    fill: "url(#paint7_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.109 254.033L302.016 212.94L301.309 213.647L342.402 254.74L343.109 254.033Z",
    fill: "black",
    mask: "url(#path-15-inside-8_201_12134)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-9_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.756 258.303L383.849 299.396L342.756 340.49L301.662 299.396L342.756 258.303Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.756 258.303L383.849 299.396L342.756 340.49L301.662 299.396L342.756 258.303Z",
    fill: "url(#paint8_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.109 340.136L302.016 299.043L301.309 299.75L342.402 340.843L343.109 340.136Z",
    fill: "black",
    mask: "url(#path-17-inside-9_201_12134)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-10_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.756 344.404L383.849 385.497L342.756 426.591L301.662 385.497L342.756 344.404Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.756 344.404L383.849 385.497L342.756 426.591L301.662 385.497L342.756 344.404Z",
    fill: "url(#paint9_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.109 426.237L302.016 385.144L301.309 385.851L342.402 426.944L343.109 426.237Z",
    fill: "black",
    mask: "url(#path-19-inside-10_201_12134)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-11_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.906 43.0501L513 84.1436L471.906 125.237L430.813 84.1435L471.906 43.0501Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.906 43.0501L513 84.1436L471.906 125.237L430.813 84.1435L471.906 43.0501Z",
    fill: "url(#paint10_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.26 124.883L431.166 83.79L430.459 84.4971L471.553 125.591L472.26 124.883Z",
    fill: "#100125",
    mask: "url(#path-21-inside-11_201_12134)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-12_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.906 129.15L513 170.244L471.906 211.337L430.813 170.244L471.906 129.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.906 129.15L513 170.244L471.906 211.337L430.813 170.244L471.906 129.15Z",
    fill: "url(#paint11_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.26 210.984L431.166 169.89L430.459 170.597L471.553 211.691L472.26 210.984Z",
    fill: "#100125",
    mask: "url(#path-23-inside-12_201_12134)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-13_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.906 215.25L513 256.344L471.906 297.437L430.813 256.344L471.906 215.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.906 215.25L513 256.344L471.906 297.437L430.813 256.344L471.906 215.25Z",
    fill: "url(#paint12_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.26 297.084L431.166 255.99L430.459 256.697L471.553 297.791L472.26 297.084Z",
    fill: "#100125",
    mask: "url(#path-25-inside-13_201_12134)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-14_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.906 301.353L513 342.446L471.906 383.54L430.813 342.446L471.906 301.353Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.906 301.353L513 342.446L471.906 383.54L430.813 342.446L471.906 301.353Z",
    fill: "url(#paint13_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.26 383.186L431.166 342.093L430.459 342.8L471.553 383.893L472.26 383.186Z",
    fill: "#100125",
    mask: "url(#path-27-inside-14_201_12134)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-15_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.906 387.452L513 428.545L471.906 469.639L430.813 428.545L471.906 387.452Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.906 387.452L513 428.545L471.906 469.639L430.813 428.545L471.906 387.452Z",
    fill: "url(#paint14_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.26 469.285L431.166 428.192L430.459 428.899L471.553 469.992L472.26 469.285Z",
    fill: "#100125",
    mask: "url(#path-29-inside-15_201_12134)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-16_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.852 86.1005L469.945 127.194L428.852 168.287L387.758 127.194L428.852 86.1005Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.852 86.1005L469.945 127.194L428.852 168.287L387.758 127.194L428.852 86.1005Z",
    fill: "url(#paint15_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.205 167.934L388.112 126.84L387.405 127.548L428.498 168.641L429.205 167.934Z",
    fill: "black",
    mask: "url(#path-31-inside-16_201_12134)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-17_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.852 172.2L469.945 213.293L428.852 254.387L387.758 213.293L428.852 172.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.852 172.2L469.945 213.293L428.852 254.387L387.758 213.293L428.852 172.2Z",
    fill: "url(#paint16_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.205 254.033L388.112 212.94L387.405 213.647L428.498 254.74L429.205 254.033Z",
    fill: "black",
    mask: "url(#path-33-inside-17_201_12134)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-18_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.852 258.303L469.945 299.396L428.852 340.49L387.758 299.396L428.852 258.303Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.852 258.303L469.945 299.396L428.852 340.49L387.758 299.396L428.852 258.303Z",
    fill: "url(#paint17_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.205 340.136L388.112 299.043L387.405 299.75L428.498 340.843L429.205 340.136Z",
    fill: "black",
    mask: "url(#path-35-inside-18_201_12134)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-37-inside-19_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.852 344.404L469.945 385.497L428.852 426.591L387.758 385.497L428.852 344.404Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.852 344.404L469.945 385.497L428.852 426.591L387.758 385.497L428.852 344.404Z",
    fill: "url(#paint18_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.205 426.237L388.112 385.144L387.405 385.851L428.498 426.944L429.205 426.237Z",
    fill: "black",
    mask: "url(#path-37-inside-19_201_12134)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-39-inside-20_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.705 129.15L340.799 170.244L299.705 211.337L258.612 170.244L299.705 129.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.705 129.15L340.799 170.244L299.705 211.337L258.612 170.244L299.705 129.15Z",
    fill: "url(#paint19_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.059 210.984L258.965 169.89L258.258 170.597L299.352 211.691L300.059 210.984Z",
    fill: "black",
    mask: "url(#path-39-inside-20_201_12134)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-41-inside-21_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.705 215.25L340.799 256.344L299.705 297.437L258.612 256.344L299.705 215.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.705 215.25L340.799 256.344L299.705 297.437L258.612 256.344L299.705 215.25Z",
    fill: "url(#paint20_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.059 297.084L258.965 255.99L258.258 256.697L299.352 297.791L300.059 297.084Z",
    fill: "black",
    mask: "url(#path-41-inside-21_201_12134)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-22_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.705 301.353L340.799 342.446L299.705 383.54L258.612 342.446L299.705 301.353Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.705 301.353L340.799 342.446L299.705 383.54L258.612 342.446L299.705 301.353Z",
    fill: "url(#paint21_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.059 383.186L258.965 342.093L258.258 342.8L299.352 383.893L300.059 383.186Z",
    fill: "black",
    mask: "url(#path-43-inside-22_201_12134)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-23_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.705 387.452L340.799 428.545L299.705 469.639L258.612 428.545L299.705 387.452Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.705 387.452L340.799 428.545L299.705 469.639L258.612 428.545L299.705 387.452Z",
    fill: "url(#paint22_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.059 469.285L258.965 428.192L258.258 428.899L299.352 469.992L300.059 469.285Z",
    fill: "black",
    mask: "url(#path-45-inside-23_201_12134)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-47-inside-24_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.601 43.0501L254.694 84.1436L213.601 125.237L172.507 84.1435L213.601 43.0501Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.601 43.0501L254.694 84.1436L213.601 125.237L172.507 84.1435L213.601 43.0501Z",
    fill: "url(#paint23_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.954 124.883L172.861 83.79L172.154 84.4971L213.247 125.591L213.954 124.883Z",
    fill: "black",
    mask: "url(#path-47-inside-24_201_12134)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-25_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.655 86.1005L297.748 127.194L256.655 168.287L215.562 127.194L256.655 86.1005Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.655 86.1005L297.748 127.194L256.655 168.287L215.562 127.194L256.655 86.1005Z",
    fill: "url(#paint24_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.009 167.934L215.915 126.84L215.208 127.548L256.301 168.641L257.009 167.934Z",
    fill: "black",
    mask: "url(#path-49-inside-25_201_12134)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-26_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.756 -0.000305176L383.849 41.0931L342.756 82.1866L301.662 41.0931L342.756 -0.000305176Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.756 -0.000305176L383.849 41.0931L342.756 82.1866L301.662 41.0931L342.756 -0.000305176Z",
    fill: "url(#paint25_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.109 81.833L302.016 40.7396L301.309 41.4467L342.402 82.5401L343.109 81.833Z",
    fill: "#100125",
    mask: "url(#path-51-inside-26_201_12134)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-27_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.852 -0.000305176L469.945 41.0931L428.852 82.1866L387.758 41.0931L428.852 -0.000305176Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.852 -0.000305176L469.945 41.0931L428.852 82.1866L387.758 41.0931L428.852 -0.000305176Z",
    fill: "url(#paint26_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.205 81.833L388.112 40.7396L387.405 41.4467L428.498 82.5401L429.205 81.833Z",
    fill: "#100125",
    mask: "url(#path-53-inside-27_201_12134)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-55-inside-28_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.655 -0.000305176L297.748 41.0931L256.655 82.1866L215.562 41.0931L256.655 -0.000305176Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.655 -0.000305176L297.748 41.0931L256.655 82.1866L215.562 41.0931L256.655 -0.000305176Z",
    fill: "url(#paint27_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.009 81.833L215.915 40.7396L215.208 41.4467L256.301 82.5401L257.009 81.833Z",
    fill: "#100125",
    mask: "url(#path-55-inside-28_201_12134)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-57-inside-29_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.655 172.2L297.748 213.293L256.655 254.387L215.562 213.293L256.655 172.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.655 172.2L297.748 213.293L256.655 254.387L215.562 213.293L256.655 172.2Z",
    fill: "url(#paint28_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.009 254.033L215.915 212.94L215.208 213.647L256.301 254.74L257.009 254.033Z",
    fill: "black",
    mask: "url(#path-57-inside-29_201_12134)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-59-inside-30_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.551 172.2L211.644 213.293L170.551 254.387L129.457 213.293L170.551 172.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.551 172.2L211.644 213.293L170.551 254.387L129.457 213.293L170.551 172.2Z",
    fill: "url(#paint29_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.904 254.033L129.811 212.94L129.104 213.647L170.197 254.74L170.904 254.033Z",
    fill: "black",
    mask: "url(#path-59-inside-30_201_12134)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-61-inside-31_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.792 213.471L167.885 254.565L126.792 295.658L85.6981 254.565L126.792 213.471Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.792 213.471L167.885 254.565L126.792 295.658L85.6981 254.565L126.792 213.471Z",
    fill: "url(#paint30_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.145 295.305L86.0516 254.211L85.3445 254.918L126.438 296.012L127.145 295.305Z",
    fill: "black",
    mask: "url(#path-61-inside-31_201_12134)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-63-inside-32_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.655 258.303L297.748 299.396L256.655 340.49L215.562 299.396L256.655 258.303Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.655 258.303L297.748 299.396L256.655 340.49L215.562 299.396L256.655 258.303Z",
    fill: "url(#paint31_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.009 340.136L215.915 299.043L215.208 299.75L256.301 340.843L257.009 340.136Z",
    fill: "black",
    mask: "url(#path-63-inside-32_201_12134)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-65-inside-33_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.551 258.303L211.644 299.396L170.551 340.49L129.457 299.396L170.551 258.303Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.551 258.303L211.644 299.396L170.551 340.49L129.457 299.396L170.551 258.303Z",
    fill: "url(#paint32_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.904 340.136L129.811 299.043L129.104 299.75L170.197 340.843L170.904 340.136Z",
    fill: "black",
    mask: "url(#path-65-inside-33_201_12134)"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-67-inside-34_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5 301.353L168.593 342.446L127.5 383.54L86.4066 342.446L127.5 301.353Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.5 301.353L168.593 342.446L127.5 383.54L86.4066 342.446L127.5 301.353Z",
    fill: "url(#paint33_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.854 383.186L86.7601 342.093L86.053 342.8L127.146 383.893L127.854 383.186Z",
    fill: "black",
    mask: "url(#path-67-inside-34_201_12134)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-69-inside-35_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.655 344.404L297.748 385.497L256.655 426.591L215.562 385.497L256.655 344.404Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.655 344.404L297.748 385.497L256.655 426.591L215.562 385.497L256.655 344.404Z",
    fill: "url(#paint34_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.009 426.237L215.915 385.144L215.208 385.851L256.301 426.944L257.009 426.237Z",
    fill: "black",
    mask: "url(#path-69-inside-35_201_12134)"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-71-inside-36_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.551 344.404L211.644 385.497L170.551 426.591L129.457 385.497L170.551 344.404Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.551 344.404L211.644 385.497L170.551 426.591L129.457 385.497L170.551 344.404Z",
    fill: "url(#paint35_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.904 426.237L129.811 385.144L129.104 385.851L170.197 426.944L170.904 426.237Z",
    fill: "black",
    mask: "url(#path-71-inside-36_201_12134)"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-73-inside-37_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4497 344.404L125.543 385.497L84.4497 426.591L43.3563 385.497L84.4497 344.404Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.4497 344.404L125.543 385.497L84.4497 426.591L43.3563 385.497L84.4497 344.404Z",
    fill: "url(#paint36_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8033 426.237L43.7098 385.144L43.0027 385.851L84.0962 426.944L84.8033 426.237Z",
    fill: "black",
    mask: "url(#path-73-inside-37_201_12134)"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-75-inside-38_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4497 429.589L125.543 470.682L84.4497 511.776L43.3563 470.682L84.4497 429.589Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.4497 429.589L125.543 470.682L84.4497 511.776L43.3563 470.682L84.4497 429.589Z",
    fill: "url(#paint37_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8033 511.422L43.7098 470.329L43.0027 471.036L84.0962 512.129L84.8033 511.422Z",
    fill: "black",
    mask: "url(#path-75-inside-38_201_12134)"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-77-inside-39_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.424 429.589L211.518 470.682L170.424 511.776L129.331 470.682L170.424 429.589Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.424 429.589L211.518 470.682L170.424 511.776L129.331 470.682L170.424 429.589Z",
    fill: "url(#paint38_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.778 511.422L129.684 470.329L128.977 471.036L170.071 512.129L170.778 511.422Z",
    fill: "black",
    mask: "url(#path-77-inside-39_201_12134)"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-79-inside-40_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.399 429.589L297.493 470.682L256.399 511.776L215.306 470.682L256.399 429.589Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.399 429.589L297.493 470.682L256.399 511.776L215.306 470.682L256.399 429.589Z",
    fill: "url(#paint39_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.753 511.422L215.659 470.329L214.952 471.036L256.046 512.129L256.753 511.422Z",
    fill: "black",
    mask: "url(#path-79-inside-40_201_12134)"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-81-inside-41_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.374 429.589L383.467 470.682L342.374 511.776L301.28 470.682L342.374 429.589Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.374 429.589L383.467 470.682L342.374 511.776L301.28 470.682L342.374 429.589Z",
    fill: "url(#paint40_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.727 511.422L301.634 470.329L300.927 471.036L342.02 512.129L342.727 511.422Z",
    fill: "black",
    mask: "url(#path-81-inside-41_201_12134)"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-83-inside-42_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.348 429.589L469.441 470.682L428.348 511.776L387.254 470.682L428.348 429.589Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.348 429.589L469.441 470.682L428.348 511.776L387.254 470.682L428.348 429.589Z",
    fill: "url(#paint41_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.701 511.422L387.608 470.329L386.901 471.036L427.994 512.129L428.701 511.422Z",
    fill: "black",
    mask: "url(#path-83-inside-42_201_12134)"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-85-inside-43_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.601 129.15L254.694 170.244L213.601 211.337L172.507 170.244L213.601 129.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.601 129.15L254.694 170.244L213.601 211.337L172.507 170.244L213.601 129.15Z",
    fill: "url(#paint42_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.954 210.984L172.861 169.89L172.154 170.597L213.247 211.691L213.954 210.984Z",
    fill: "black",
    mask: "url(#path-85-inside-43_201_12134)"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-87-inside-44_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.601 215.25L254.694 256.344L213.601 297.437L172.507 256.344L213.601 215.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.601 215.25L254.694 256.344L213.601 297.437L172.507 256.344L213.601 215.25Z",
    fill: "url(#paint43_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.954 297.084L172.861 255.99L172.154 256.697L213.247 297.791L213.954 297.084Z",
    fill: "black",
    mask: "url(#path-87-inside-44_201_12134)"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-89-inside-45_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.601 301.353L254.694 342.446L213.601 383.54L172.507 342.446L213.601 301.353Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.601 301.353L254.694 342.446L213.601 383.54L172.507 342.446L213.601 301.353Z",
    fill: "url(#paint44_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.954 383.186L172.861 342.093L172.154 342.8L213.247 383.893L213.954 383.186Z",
    fill: "black",
    mask: "url(#path-89-inside-45_201_12134)"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-91-inside-46_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.601 387.452L254.694 428.545L213.601 469.639L172.507 428.545L213.601 387.452Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.601 387.452L254.694 428.545L213.601 469.639L172.507 428.545L213.601 387.452Z",
    fill: "url(#paint45_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.954 469.285L172.861 428.192L172.154 428.899L213.247 469.992L213.954 469.285Z",
    fill: "black",
    mask: "url(#path-91-inside-46_201_12134)"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-93-inside-47_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5 387.452L168.593 428.545L127.5 469.639L86.4066 428.545L127.5 387.452Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.5 387.452L168.593 428.545L127.5 469.639L86.4066 428.545L127.5 387.452Z",
    fill: "url(#paint46_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.854 469.285L86.7601 428.192L86.053 428.899L127.146 469.992L127.854 469.285Z",
    fill: "black",
    mask: "url(#path-93-inside-47_201_12134)"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-95-inside-48_201_12134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3992 387.452L82.4926 428.545L41.3992 469.639L0.305731 428.545L41.3992 387.452Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.3992 387.452L82.4926 428.545L41.3992 469.639L0.305731 428.545L41.3992 387.452Z",
    fill: "url(#paint47_linear_201_12134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7527 469.285L0.659284 428.192L-0.0478225 428.899L41.0456 469.992L41.7527 469.285Z",
    fill: "black",
    mask: "url(#path-95-inside-48_201_12134)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_12134",
    x1: 345.69,
    y1: 84.1436,
    x2: 427.877,
    y2: 84.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_12134",
    x1: 345.69,
    y1: 170.244,
    x2: 427.877,
    y2: 170.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_12134",
    x1: 345.69,
    y1: 256.344,
    x2: 427.877,
    y2: 256.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_201_12134",
    x1: 345.69,
    y1: 342.446,
    x2: 427.877,
    y2: 342.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_201_12134",
    x1: 345.69,
    y1: 428.545,
    x2: 427.877,
    y2: 428.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_201_12134",
    x1: 259.59,
    y1: 84.1436,
    x2: 341.777,
    y2: 84.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_201_12134",
    x1: 302.641,
    y1: 127.194,
    x2: 384.828,
    y2: 127.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_201_12134",
    x1: 302.641,
    y1: 213.293,
    x2: 384.828,
    y2: 213.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_201_12134",
    x1: 302.641,
    y1: 299.396,
    x2: 384.828,
    y2: 299.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_201_12134",
    x1: 302.641,
    y1: 385.497,
    x2: 384.828,
    y2: 385.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_201_12134",
    x1: 431.791,
    y1: 84.1436,
    x2: 513.978,
    y2: 84.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110228",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1D083D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_201_12134",
    x1: 431.791,
    y1: 170.244,
    x2: 513.978,
    y2: 170.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110228",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1D083D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_201_12134",
    x1: 431.791,
    y1: 256.344,
    x2: 513.978,
    y2: 256.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110228",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1D083D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_201_12134",
    x1: 431.791,
    y1: 342.446,
    x2: 513.978,
    y2: 342.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110228",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1D083D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_201_12134",
    x1: 431.791,
    y1: 428.545,
    x2: 513.978,
    y2: 428.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110228",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1D083D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_201_12134",
    x1: 388.737,
    y1: 127.194,
    x2: 470.923,
    y2: 127.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_201_12134",
    x1: 388.737,
    y1: 213.293,
    x2: 470.923,
    y2: 213.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_201_12134",
    x1: 388.737,
    y1: 299.396,
    x2: 470.923,
    y2: 299.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_201_12134",
    x1: 388.737,
    y1: 385.497,
    x2: 470.923,
    y2: 385.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_201_12134",
    x1: 259.59,
    y1: 170.244,
    x2: 341.777,
    y2: 170.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_201_12134",
    x1: 259.59,
    y1: 256.344,
    x2: 341.777,
    y2: 256.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_201_12134",
    x1: 259.59,
    y1: 342.446,
    x2: 341.777,
    y2: 342.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_201_12134",
    x1: 259.59,
    y1: 428.545,
    x2: 341.777,
    y2: 428.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_201_12134",
    x1: 173.486,
    y1: 84.1436,
    x2: 255.673,
    y2: 84.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_201_12134",
    x1: 216.54,
    y1: 127.194,
    x2: 298.727,
    y2: 127.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_201_12134",
    x1: 302.641,
    y1: 41.0931,
    x2: 384.828,
    y2: 41.0931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110228",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1D083D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_201_12134",
    x1: 388.737,
    y1: 41.0931,
    x2: 470.923,
    y2: 41.0931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110228",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1D083D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_201_12134",
    x1: 216.54,
    y1: 41.0931,
    x2: 298.727,
    y2: 41.0931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110228",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1D083D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_201_12134",
    x1: 216.54,
    y1: 213.293,
    x2: 298.727,
    y2: 213.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_201_12134",
    x1: 130.436,
    y1: 213.293,
    x2: 212.622,
    y2: 213.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_201_12134",
    x1: 86.6765,
    y1: 254.565,
    x2: 168.863,
    y2: 254.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_201_12134",
    x1: 216.54,
    y1: 299.396,
    x2: 298.727,
    y2: 299.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_201_12134",
    x1: 130.436,
    y1: 299.396,
    x2: 212.622,
    y2: 299.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_201_12134",
    x1: 87.385,
    y1: 342.446,
    x2: 169.572,
    y2: 342.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_201_12134",
    x1: 216.54,
    y1: 385.497,
    x2: 298.727,
    y2: 385.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_201_12134",
    x1: 130.436,
    y1: 385.497,
    x2: 212.622,
    y2: 385.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_201_12134",
    x1: 44.3347,
    y1: 385.497,
    x2: 126.522,
    y2: 385.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_201_12134",
    x1: 44.3347,
    y1: 470.682,
    x2: 126.522,
    y2: 470.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_201_12134",
    x1: 130.309,
    y1: 470.682,
    x2: 212.496,
    y2: 470.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_201_12134",
    x1: 216.284,
    y1: 470.682,
    x2: 298.471,
    y2: 470.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_201_12134",
    x1: 302.259,
    y1: 470.682,
    x2: 384.445,
    y2: 470.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_201_12134",
    x1: 388.233,
    y1: 470.682,
    x2: 470.42,
    y2: 470.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_201_12134",
    x1: 173.486,
    y1: 170.244,
    x2: 255.673,
    y2: 170.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_201_12134",
    x1: 173.486,
    y1: 256.344,
    x2: 255.673,
    y2: 256.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_201_12134",
    x1: 173.486,
    y1: 342.446,
    x2: 255.673,
    y2: 342.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_201_12134",
    x1: 173.486,
    y1: 428.545,
    x2: 255.673,
    y2: 428.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_201_12134",
    x1: 87.385,
    y1: 428.545,
    x2: 169.572,
    y2: 428.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_201_12134",
    x1: 1.28415,
    y1: 428.545,
    x2: 83.471,
    y2: 428.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBackground);
export default __webpack_public_path__ + "static/media/card-background.af229edf385bea824eb4900ab42bb5f0.svg";
export { ForwardRef as ReactComponent };